import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { ApiService } from '../../../shared/services/api.service';

@Injectable({
    providedIn: 'root'
})
export class DepartmentService extends ApiService {
    constructor(protected override http: HttpClient, protected override toastr: ToastrService) {
        super('/department', http, toastr);
    }

    public getDepartment(id: string): Observable<any> {
        return this.get(id);
    }

    public getDepartments(): Observable<any> {
        return this.getAll('');
    }
}
